<template>
  <div id="job-create">
    <vx-card>
      <div slot="no-body" class="p-6">
        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          error-color="rgba(var(--vs-danger), 1)"
          :title="null"
          :subtitle="null"
          next-button-text="Weiter"
          back-button-text="Zurück"
          finish-button-text="Erstellen"
          @on-complete="submit"
        >
          <tab-content
            title="Stammdaten"
            class="mb-5"
            icon="fad fa-home"
            :before-change="validateStep1"
          >
            <ValidationObserver ref="stepOne" tag="form">
              <ProjectGeneral v-if="vacancyProject" v-model="vacancyProject" />
              <div class="mt-6">
                <h4 class="mb-4">Optionen</h4>
                <vs-checkbox
                  v-model="createVacancy"
                  icon="fa-check"
                  icon-pack="fas"
                  >Stelle anlegen</vs-checkbox
                >
              </div>
            </ValidationObserver>
          </tab-content>

          <tab-content
            v-if="createVacancy"
            title="Stellen Daten"
            class="mb-5"
            icon="fal fa-file-alt"
            :before-change="validateStep2"
          >
            <ValidationObserver ref="stepTwo" tag="form">
              <JobGeneral v-if="vacancy" ref="jobGeneral" v-model="vacancy" />
            </ValidationObserver>
          </tab-content>
        </form-wizard>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ProjectGeneral from "../form/ProjectGeneral";
import JobGeneral from "../form/JobGeneral";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import gql from "graphql-tag";
import moment from "moment";

export default {
  components: {
    JobGeneral,
    ProjectGeneral,
    FormWizard,
    TabContent
  },
  data: () => ({
    vacancyProject: {},
    vacancy: {
      companyProfileText: null,
      jobCustomerDetailsText: null,
      jobActivitiesText: null,
      jobProfilesText: null,
      jobPerspectiveText: null,
      jobFooterText: null,
      contactType: "CONSULTANT",
      contactID: null,
      contactEmail: null,
      publication: {
        rePublishUntil: null,
        rePublishAmount: 4,
        rePublishInterval: 14
      }
    },
    createVacancy: true,
    submitted: false
  }),
  mounted() {
    if (this.$store.getters["user/hasPermission"]("vacancy_republish")) {
      this.vacancy.activeFrom = moment();
      this.vacancy.publication = {
        rePublishUntil: null,
        rePublishAmount: 4,
        rePublishInterval: 14
      };
    }
  },
  methods: {
    async validateStep1() {
      return await this.$refs.stepOne.validate();
    },
    async validateStep2() {
      return await this.$refs.stepTwo.validate();
    },
    async submit() {
      if (this.submitted == false) {
        this.submitted = true;
        if (this.createVacancy) {
          if (this.vacancy.__typename) {
            delete this.vacancy.__typename;
          }
          this.vacancyProject.vacancies = [this.vacancy];
        }

        const { data } = await this.$apollo.mutate({
          mutation: gql`
            mutation($input: CreateVacancyProjectInput!) {
              vacancyProjectCreate(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: {
              ...this.vacancyProject
            }
          }
        });

        if (data.vacancyProjectCreate.id) {
          this.$router.push({
            name: "project.edit",
            params: { id: data.vacancyProjectCreate.id }
          });
        }
      }
    }
  }
};
</script>
